var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShield10(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.47188 9.83839C7.44997 9.83839 7.42805 9.83839 7.40467 9.83693C7.02329 9.81793 6.66676 9.6382 6.4242 9.34303L5.37066 8.05716C5.16609 7.80729 5.20263 7.43906 5.4525 7.23449C5.70237 7.02992 6.07058 7.06645 6.27515 7.31632L7.32869 8.60219C7.37398 8.65772 7.43242 8.66795 7.46311 8.66941C7.49379 8.67087 7.55227 8.66649 7.60342 8.61534L10.3447 5.87409C10.5726 5.64614 10.9423 5.64614 11.1717 5.87409C11.3997 6.10204 11.3997 6.47173 11.1717 6.70114L8.43046 9.4424C8.17474 9.69519 7.82988 9.83839 7.47188 9.83839Z",
    fill: "url(#paint0_linear_2427_124317)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00075 15.3307C7.55215 15.3307 7.10208 15.2211 6.7017 15.0034C3.55276 13.2865 1.59766 10.1434 1.59766 6.80303V3.99748C1.59766 3.14997 2.17045 2.38137 3.02089 2.08328L6.2166 0.96544C7.36658 0.563603 8.63345 0.563603 9.78344 0.96544L12.9791 2.08328C13.831 2.38137 14.4024 3.14997 14.4024 3.99748V6.80303C14.4024 10.1434 12.4458 13.2865 9.2983 15.0034C8.89939 15.2226 8.45081 15.3307 8.00075 15.3307ZM8.00075 1.83195C7.52731 1.83195 7.05387 1.91085 6.60381 2.06866L3.40813 3.1865C3.01799 3.32239 2.76664 3.64094 2.76664 3.99748V6.80303C2.76664 9.71525 4.48942 12.4653 7.26136 13.9776C7.70996 14.2217 8.29008 14.2231 8.73867 13.9776C11.5121 12.4653 13.2334 9.71671 13.2334 6.80303V3.99748C13.2334 3.64094 12.9821 3.32239 12.5919 3.1865L9.39623 2.06866C8.94763 1.91085 8.47419 1.83195 8.00075 1.83195Z",
    fill: "url(#paint1_linear_2427_124317)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2427_124317",
    x1: 3.74511,
    y1: 4.85156,
    x2: 6.45546,
    y2: 11.6862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEED6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5A03A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2427_124317",
    x1: -1.53446,
    y1: -2.3562,
    x2: 11.4415,
    y2: 16.9958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEED6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5A03A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield10);
export default __webpack_public_path__ + "static/media/shield-10.d4f2db9dfe02355d17928e83dd0060b3.svg";
export { ForwardRef as ReactComponent };